export function hasActiveAudioZoneOverrideForSource(emitterId) {
  if (!emitterId) {
    return false;
  }

  return APP.zoneOverrides.has(emitterId);
}
